<template>
  <v-layout align-center column>
    <p class="title-a">Apa itu Dompet Kilat</p>
    <v-skeleton-loader
      type="image"
      class="Dompetkilat-Image"
      v-if="!isImgLoaded"
    ></v-skeleton-loader>
    <img
      src="../../assets/TentangKami/Dompetkilat-Image.png"
      @load="onImgLoad"
      class="Dompetkilat-Image"
    />
    <div class="Desc-Box">
      <p class="Desc">
        Dompet Kilat didirikan pada tahun 2016 oleh para pakar di industri
        keuangan. Kami bertekad untuk
        <span class="text-style-1"
          >mewujudkan inklusi keuangan pada masyarakat Indonesia</span
        >.
      </p>
      <p class="Desc">
        Kami percaya bahwa dengan menutup
        <span class="text-style-1">gap inklusi keuangan</span>, kami dapat
        berkontribusi memajukan Indonesia.
      </p>
    </div>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      isImgLoaded: false,
    };
  },

  methods: {
    onImgLoad() {
      this.isImgLoaded = true;
    },
  },
};
</script>

<style scoped>
.title-a {
  width: 328px;
  flex-grow: 0;
  margin: 46px 0 10px;
  font-family: Sora;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
.Desc {
  flex-grow: 0;
  font-family: Sora;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.62;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
}

.Desc-Box {
  width: 328px;
  flex-grow: 0;
  margin: 16px 0 0;
  font-family: Sora;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.62;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
}

.Desc .text-style-1 {
  font-weight: bold;
}
.Dompetkilat-Image {
  width: 327.8px;
  height: 204.1px;
  flex-grow: 0;
  margin: 32px 0.2px 16px 0;
  object-fit: contain;
}
</style>
